import { render, staticRenderFns } from "./msRadio.vue?vue&type=template&id=73edaf86&scoped=true"
import script from "./msRadio.vue?vue&type=script&lang=js"
export * from "./msRadio.vue?vue&type=script&lang=js"
import style0 from "./msRadio.vue?vue&type=style&index=0&id=73edaf86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73edaf86",
  null
  
)

export default component.exports